import React from "react";

import styles from "./AcademyPartList.module.scss";

const ProgressBar = ({ percentage, colorStyle="BLUE" }) => {
  return (
    <div className={styles["progressbar-container-"+colorStyle]}>
      <div
        className={styles["progressbar-percentage"]}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
